function TableHeader(props) {
  return <div {...props}></div>
}

export default TableHeader
